module.exports = __webpack_public_path__ + "static/media/love.384510cc.jpg";